export default function ($locationProvider) {
    'ngInject';

    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
}



// WEBPACK FOOTER //
// ./src/js/config/locationProvider.js